import "core-js/modules/es.string.link.js";
import { defineComponent as _defineComponent } from 'vue';
import RichText from '~/components/ui/RichText.vue';
import { useGetDisplayOptionsClassesGraphQL } from '~/composables/useGetDisplayOptionsClassesGraphQL';
import { generateTwicPicBackgroundImageSet } from '~/composables/useResponsiveBackground';
import AzImg from '~/components/Atoms/AzImg.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ItemImageTextStandardGraphql',
  props: {
    image: {
      type: Object,
      default: function _default() {}
    },
    text: {
      type: Object,
      default: function _default() {}
    },
    title: {
      type: String,
      default: ''
    },
    classes: {
      type: Object,
      default: function _default() {}
    },
    link: {
      type: String,
      default: ''
    },
    isHomePage: {
      type: Boolean,
      default: false
    },
    displayOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      $config = _useNuxt2App.$config,
      $trackers = _useNuxt2App.$trackers;
    var customRenderer = function customRenderer() {
      return {
        renderNode: {
          paragraph: function paragraph(node, next) {
            return "<h4 class=\"line-clamp-2\">".concat(next(node.content), "</h4>");
          }
        },
        renderMark: {}
      };
    };
    var backgroundImage = computed(function () {
      if (props.isHomePage) {
        var _props$image;
        return generateTwicPicBackgroundImageSet($config.public.cloudinaryDomain, (_props$image = props.image) === null || _props$image === void 0 ? void 0 : _props$image.url, 220);
      }
    });
    var jsonData = computed(function () {
      var _props$text;
      return (_props$text = props.text) === null || _props$text === void 0 ? void 0 : _props$text.json;
    });
    var displayOptionsClasses = useGetDisplayOptionsClassesGraphQL(props.displayOptions);
    var trackingEvent = function trackingEvent() {
      if (props.isHomePage) {
        $trackers.gtm.pushEvent('universes_homepage', {
          event_label: 'universes_homepage',
          event_name: 'universes_homepage',
          target_page: props.link
        });
      }
    };
    return {
      __sfc: true,
      props: props,
      $config: $config,
      $trackers: $trackers,
      customRenderer: customRenderer,
      backgroundImage: backgroundImage,
      jsonData: jsonData,
      displayOptionsClasses: displayOptionsClasses,
      trackingEvent: trackingEvent,
      RichText: RichText,
      AzImg: AzImg,
      NuxtLinkCustom: NuxtLinkCustom
    };
  }
});